@if(DataLoaded){
<fieldset class="rms-fieldset">
  <legend>History of Adjustments</legend>
  <div style="display:flex; flex-direction:column; gap:10px">
    <div style="display:flex; justify-content:flex-end">
      <button class="btn-bg-green" mat-button style="min-width:auto; padding:2px 14px; font-size:0.85em; line-height:1.6" (click)="onClickAddAdjustment()">Add Adjustment</button>
    </div>
    <div class="adjustment-table" style="overflow-y:auto">
      <rms-table [data]="Adjustments" [columns]="AdjustmentColumns" [IncludePaginator]="false" [IncludeSearch]="false"></rms-table>
    </div>
  </div>
</fieldset>
}
